import { useUser } from "../contexts/UserContext";
import SEO from "../components/SEO";

export default function Profil() {
  const { user, logout } = useUser();

  if (!user) return <p>Veuillez vous connecter</p>;

  return (
    <div style={{ padding: 40 }}>
      <SEO title="Mon Profil" description="Espace privé SCI MAYEDO" noindex={true} />
      <h2>👤 Mon Profil</h2>

      <p><strong>Nom :</strong> {user.name}</p>
      <p><strong>Email :</strong> {user.email}</p>
      <p><strong>Téléphone :</strong> {user.phone}</p>

      <button onClick={logout}>Se déconnecter</button>
    </div>
  );
}